import { render, staticRenderFns } from "./Single_Job.vue?vue&type=template&id=143a4319&scoped=true&"
import script from "./Single_Job.vue?vue&type=script&lang=js&"
export * from "./Single_Job.vue?vue&type=script&lang=js&"
import style0 from "./Single_Job.vue?vue&type=style&index=0&id=143a4319&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a4319",
  null
  
)

export default component.exports